<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title pull-left" id="my-modal-title">{{ 'SUPPORTED_BROWSERS' | globalTranslate }}</h3>

    <button type="button" class="btn-close pull-right" [attr.aria-label]="'CLOSE' | globalTranslate" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="" aria-hidden="true" />
    </button>
  </div>
  <div class="modal-body">
    <div class="flex-container">
      <div class="row">
        <span class="flex-item"> <a href="https://www.microsoft.com/en-us/windows/microsoft-edge" target="_blank" title="edge v40+">
          <img class="icon_prop" alt="" aria-hidden="true" src="../../assets/images/icons8-microsoft-edge.svg" border="0">
            <p id="versionfont" class="browser-version">Version v40+</p>
          </a>
        </span>
      </div>
      <div class="row">
        <span class="flex-item"> <a href="https://support.apple.com/downloads/safari" target="_blank" title="Safari v11+">
            <img class="icon_prop" alt="" aria-hidden="true" src="../../assets/images/icons8-safari.svg" border="0">
            <p id="versionfont" class="browser-version">Version 11+</p>
          </a>
        </span>
      </div>
      <div class="row">
        <span class="flex-item"> <a href="https://www.google.com/chrome" target="_blank" title="Chrome v65+">
           <img class="icon_prop" alt="" aria-hidden="true" src="../../assets/images/icons8-chrome.svg" border="0">
            <p id="versionfont" class="browser-version">Version v65+</p>
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
